module.exports = __webpack_public_path__ + "static/flags/KG-1c97d8d5619867d52548d1e7f8344038.gif";